import api from '../api';

const ProjectBankService = {
  getSettings: () => api.get('/project-bank/settings').then((r) => r.data),
  getCompanyRegistration: () => api.get('/company').then((r) => r.data),
  saveSettings: (payload) => api.put('/project-bank/settings', payload).then((r) => r.data),
  uploadSettingsLogo: (formData) => api.post('/project-bank/settings/logo', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data),
  getDashboard: () => api.get('/project-bank/dashboard').then((r) => r.data),
  listAvailableProcesses: () => api.get('/processes/available').then((r) => r.data),
  writeWithAI: (payload) => api.post('/project-bank/ai/write', payload).then((r) => r.data),
  importDocumentWithAI: (file, prompt = '') => {
    const form = new FormData();
    form.append('file', file);
    if (prompt) form.append('prompt', prompt);
    return api.post('/project-bank/ai/import-document', form, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
  },
  getAIIntegrationSettings: () => api.get('/project-bank/ai/settings').then((r) => r.data),
  saveAIIntegrationSettings: (payload) => api.put('/project-bank/ai/settings', payload).then((r) => r.data),
  getNashAIIntegrationSettings: () => api.get('/chat/assistant/settings').then((r) => r.data),
  saveNashAIIntegrationSettings: (payload) => api.put('/chat/assistant/settings', payload).then((r) => r.data),
  listProjects: (params = {}) => api.get('/project-bank', { params }).then((r) => r.data),
  createProject: (payload) => api.post('/project-bank', payload).then((r) => r.data),
  updateProject: (id, payload) => api.put(`/project-bank/${id}`, payload).then((r) => r.data),
  getProject: (id) => api.get(`/project-bank/${id}`).then((r) => r.data),
  archiveProject: (id) => api.patch(`/project-bank/${id}/archive`).then((r) => r.data),
  deleteProject: (id) => api.delete(`/project-bank/${id}`).then((r) => r.data),
  changeStatus: (id, status) => api.patch(`/project-bank/${id}/status`, { status }).then((r) => r.data),
  saveBudget: (id, payload) => api.put(`/project-bank/${id}/budget`, payload).then((r) => r.data),
  createStage: (id, payload) => api.post(`/project-bank/${id}/stages`, payload).then((r) => r.data),
  updateStage: (projectId, stageId, payload) => api.put(`/project-bank/${projectId}/stages/${stageId}`, payload).then((r) => r.data),
  deleteStage: (projectId, stageId) => api.delete(`/project-bank/${projectId}/stages/${stageId}`).then((r) => r.data),
  completeStage: (projectId, stageId) => api.patch(`/project-bank/${projectId}/stages/${stageId}/complete`).then((r) => r.data),
  createFollowUp: (id, payload) => api.post(`/project-bank/${id}/follow-ups`, payload).then((r) => r.data),
  createSource: (id, payload) => api.post(`/project-bank/${id}/resource-sources`, payload).then((r) => r.data),
  updateSource: (projectId, sourceId, payload) => api.put(`/project-bank/${projectId}/resource-sources/${sourceId}`, payload).then((r) => r.data),
  deleteSource: (projectId, sourceId) => api.delete(`/project-bank/${projectId}/resource-sources/${sourceId}`).then((r) => r.data),
  createExpense: (id, payload) => api.post(`/project-bank/${id}/expenses`, payload).then((r) => r.data),
  updateExpense: (projectId, expenseId, payload) => api.put(`/project-bank/${projectId}/expenses/${expenseId}`, payload).then((r) => r.data),
  deleteExpense: (projectId, expenseId) => api.delete(`/project-bank/${projectId}/expenses/${expenseId}`).then((r) => r.data),
  uploadFiles: (id, formData) => api.post(`/project-bank/${id}/files`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data),
  renameAttachment: (attachmentId, payload) => api.put(`/project-bank/files/${attachmentId}`, payload).then((r) => r.data),
  saveChart: (id, payload) => api.post(id ? `/project-bank/${id}/charts` : '/project-bank/charts', payload).then((r) => r.data),
  chartData: (id) => api.get(id ? `/project-bank/${id}/charts/data` : '/project-bank/charts/data').then((r) => r.data),
  generatePdf: (id, payload) => api.post(`/project-bank/${id}/pdf`, payload).then((r) => r.data),
  listPdfs: (id) => api.get(`/project-bank/${id}/pdfs`).then((r) => r.data),
  downloadPdfUrl: (pdfId) => `${api.defaults.baseURL}/project-bank/pdfs/${pdfId}/download`,
  downloadAttachmentUrl: (attachmentId) => `${api.defaults.baseURL}/project-bank/files/${attachmentId}/download`,
  getPdfBlobUrl: async (pdfId) => {
    const response = await api.get(`/project-bank/pdfs/${pdfId}/download`, { responseType: 'blob' });
    return URL.createObjectURL(response.data);
  },
  getAttachmentBlobUrl: async (attachmentId) => {
    const response = await api.get(`/project-bank/files/${attachmentId}/download`, { responseType: 'blob' });
    return URL.createObjectURL(response.data);
  },
  openPdfDownload: async (pdfId) => {
    const url = await ProjectBankService.getPdfBlobUrl(pdfId);
    window.open(url, '_blank', 'noopener,noreferrer');
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  },
  openAttachmentDownload: async (attachmentId) => {
    const url = await ProjectBankService.getAttachmentBlobUrl(attachmentId);
    window.open(url, '_blank', 'noopener,noreferrer');
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  },
  transparencyUrl: (token) => `${api.defaults.baseURL}/project-bank/transparency/${encodeURIComponent(token || '')}`,
};

export default ProjectBankService;
